import { CalendarDays, FileText, MapPin, Save, UserRound } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

const fieldWrap = "space-y-2";
const helperText = "text-xs text-[#7A8699]";
const labelClass = "flex items-center gap-2 text-[15px] font-medium text-[#4C5A6B]";
const inputClass =
  "border-[#D8DEE8] bg-white text-[#445468] placeholder:text-[#9AA7B8] focus:border-[#0F4C5C] focus:ring-[#0F4C5C]/15";

const StepIdentificacao = ({ caseId, identificacao, onChange, onSave, readOnly }) => {
  const data = identificacao || {};

  const update = (field, value) => {
    onChange({
      ...data,
      [field]: value,
    });
  };

  const handleLocalChange = (value) => {
    onChange({
      ...data,
      local_vistoria: value,
      local: value,
    });
  };

  return (
    <section className="rounded-[22px] border border-[#DDD8CD] bg-[#F5F2EB] px-7 py-8 shadow-[0_8px_30px_rgba(15,76,92,0.04)]">
      <div className="mb-8 border-b border-[#DED8CB] pb-6">
        <div className="mb-3 flex items-center gap-3 text-[#26384B]">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#E7E3DA]">
            <FileText size={18} />
          </div>
          <h2 className="font-serif text-[2rem] leading-none">Identificação do Documento</h2>
        </div>
        <p className="max-w-4xl text-[1.05rem] leading-7 text-[#66758A]">
          Preencha as informações básicas que identificarão o laudo técnico. Esses dados aparecerão no cabeçalho das
          páginas do documento exportado.
        </p>
      </div>

      <div className="space-y-7">
        <div className={fieldWrap}>
          <Label className={labelClass}>
            <UserRound size={16} />
            Destinatário
          </Label>
          <Textarea
            value={data.destinatario || ""}
            disabled={readOnly}
            onChange={(event) => update("destinatario", event.target.value)}
            placeholder="Ex: Condomínio Residencial Villa Verde, CNPJ 00.000.000/0001-00, representado pelo síndico Sr. João Silva"
            className={`min-h-[94px] ${inputClass}`}
          />
          <p className={helperText}>Informe o nome completo, CNPJ/CPF e representante legal, quando aplicável.</p>
        </div>

        <div className={fieldWrap}>
          <Label className={labelClass}>
            <MapPin size={16} />
            Local da Vistoria
          </Label>
          <Textarea
            value={data.local_vistoria || data.local || ""}
            disabled={readOnly}
            onChange={(event) => handleLocalChange(event.target.value)}
            placeholder="Ex: Rua das Palmeiras, 123, Bloco A - Apartamento 401, Bairro Jardim Europa, São Paulo/SP, CEP 01234-567"
            className={`min-h-[94px] ${inputClass}`}
          />
          <p className={helperText}>Endereço completo do local onde foi realizada a vistoria técnica.</p>
        </div>

        <div className="grid gap-6 md:grid-cols-[260px_1fr]">
          <div className={fieldWrap}>
            <Label className={labelClass}>
              <CalendarDays size={16} />
              Data da Vistoria
            </Label>
            <Input
              type="date"
              value={data.data_vistoria || ""}
              disabled={readOnly}
              onChange={(event) => update("data_vistoria", event.target.value)}
              className={`h-12 ${inputClass}`}
            />
            <p className={helperText}>Data em que a vistoria técnica foi realizada.</p>
          </div>

          <div className="self-end rounded-xl border border-[#D7DEE7] bg-[#F8F7F4] px-4 py-4 text-sm leading-6 text-[#5D6A7E]">
            <strong className="font-semibold text-[#4C5A6B]">Código do documento:</strong>{" "}
            Será gerado automaticamente a partir do ID do caso e aparecerá no cabeçalho do documento exportado.
            <div className="mt-2 font-mono text-xs text-[#7D8797]">{caseId || "Aguardando geração do caso"}</div>
          </div>
        </div>

        {!readOnly && (
          <div className="flex justify-end pt-2">
            <Button onClick={onSave} className="h-12 rounded-xl px-6 text-sm shadow-sm">
              <Save size={16} className="mr-2" />
              Salvar Identificação
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default StepIdentificacao;
